var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from 'react';
import MaestroLogo from '../images/logos/MaestroLogo';
import { makeStyles, Typography } from '@material-ui/core';
import { Select, usePhoneView } from '@michelin/acid-components';
export var useStyles = makeStyles(function (theme) {
    var _a, _b, _c, _d, _e;
    return ({
        container: {
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
        },
        typographyRoot: (_a = {},
            _a[theme.breakpoints.down('xs')] = {
                marginTop: theme.spacing(1),
            },
            _a[theme.breakpoints.up('sm')] = {
                marginTop: theme.spacing(2),
            },
            _a.color = '#fff',
            _a),
        header: (_b = {
                textAlign: 'center'
            },
            _b[theme.breakpoints.down('xs')] = {
                padding: '75px 0 30px 0',
            },
            _b[theme.breakpoints.up('sm')] = {
                padding: '100px 0 50px 0',
            },
            _b.background = '#2b2b33',
            _b),
        logoContainer: (_c = {
                display: 'flex',
                justifyContent: 'center'
            },
            _c[theme.breakpoints.down('xs')] = {
                height: '55px',
            },
            _c[theme.breakpoints.up('sm')] = {
                height: '70px',
            },
            _c),
        messageContainer: (_d = {
                textAlign: 'center'
            },
            _d[theme.breakpoints.down('xs')] = {
                padding: '30px 25px',
            },
            _d[theme.breakpoints.up('sm')] = {
                padding: '30px 0px',
            },
            _d.background = '#e3e5e7',
            _d.color = '#2b2b33',
            _d),
        supportContainer: (_e = {
                textAlign: 'center',
                background: '#fff',
                flex: '1 1 auto'
            },
            _e[theme.breakpoints.down('xs')] = {
                padding: '25px 0',
            },
            _e[theme.breakpoints.up('sm')] = {
                padding: '50px 0px',
            },
            _e),
        support: {
            marginBottom: '12px',
            fontSize: '10px',
            letterSpacing: '2px',
            color: '#2b2b33'
        },
        link: {
            textDecoration: 'none',
            color: '#0491d2',
            fontSize: '12px'
        },
        select: {
            position: 'fixed',
            top: theme.spacing(1),
            right: theme.spacing(1),
            '&:before': {
                borderColor: '#fff',
            },
            '&:after': {
                borderColor: '#fff',
            },
            '&:not(.Mui-disabled):hover::before': {
                borderColor: '#fff',
            },
        },
        icon: {
            fill: '#fff',
        },
        root: {
            color: '#fff',
        },
    });
});
var FR_APPS = {
    "Maestro": "Maestro",
    "Fleet Manager": "Gestionnaire de flotte",
    "Urban Fleet Order": "Commande de flotte urbaine",
    "Mechanical Care": "Entretien mécanique",
    "Fleet Order": "Commande de flotte",
    "Digital Tire Service Manual": "Manuel d'entretien des pneus numériques",
    "Maestro Reporting Dashboard": "Maestro Tableau de bord des rapports",
    "Maestro Catalog": "Maestro Catalogue",
    "Fleet Profile": "Profil de la flotte",
    "Maestro Monitor": "Maestro Moniteur",
    "Service Provider / Store Profile": "Fournisseur de service / Profil du détaillant",
    "Maestro Central": "Maestro Centrale",
    "Live Track": "Piste en direct",
};
var TEXTS = {
    UNDER_MAINTENANCE: {
        en_US: 'Oops! Site under maintenance',
        fr_CA: 'Oops! Site en maintenance',
    },
    MAIN: {
        en_US: 'Sorry for the inconvenience but we are performing some maintenance at the moment. We will be back online as soon as possible. Thank you!',
        fr_CA: 'Désolé pour la gêne occasionnée, mais nous effectuons actuellement des travaux de maintenance. Nous serons de retour en ligne dès que possible. Merci!',
    },
    CONTACT: {
        en_US: 'Please contact our support team at maestro.support@michelin.com to report this issue.',
        fr_CA: "Veuillez contacter notre équipe d'assistance à maestro.support@michelin.com pour signaler ce problème.",
    },
    SUPPORT: {
        en_US: 'SUPPORT',
        fr_CA: 'SUPPORT',
    },
};
export var AppOffline = function (props) {
    var messageEn = props.messageEn, messageFr = props.messageFr, application = props.application;
    var classes = useStyles();
    var phoneView = usePhoneView();
    var _a = __read(useState('en_US'), 2), language = _a[0], setLanguage = _a[1];
    var message = language === 'en_US' ? messageEn : messageFr;
    var app = application || 'Maestro';
    return (React.createElement("div", { className: classes.container },
        React.createElement("div", { className: classes.header },
            React.createElement(Select, { className: classes.select, inputProps: {
                    classes: {
                        icon: classes.icon,
                        root: classes.root,
                    },
                }, value: language, onChange: function (e) { return setLanguage(String(e.target.value)); }, options: [
                    { value: 'en_US', label: 'English (Americas)' },
                    { value: 'fr_CA', label: 'Français (Canada)' },
                ], SelectDisplayProps: __assign({}, (phoneView && { style: { fontSize: 'small' } })), MenuProps: __assign({}, (phoneView && { MenuListProps: { className: 'phone-view' } })) }),
            React.createElement("div", { className: classes.logoContainer },
                React.createElement(MaestroLogo, null)),
            React.createElement(Typography, { variant: phoneView ? 'h6' : 'h4', classes: { root: classes.typographyRoot } }, language === 'en_US' ? app : FR_APPS[app]),
            React.createElement(Typography, { variant: phoneView ? 'subtitle1' : 'h5', classes: { root: classes.typographyRoot } }, TEXTS.UNDER_MAINTENANCE[language])),
        React.createElement("div", { className: classes.messageContainer },
            React.createElement(Typography, { variant: 'body2' }, TEXTS.MAIN[language]),
            React.createElement("br", null),
            message &&
                React.createElement(React.Fragment, null,
                    React.createElement(Typography, { variant: 'body2' }, message),
                    React.createElement("br", null)),
            React.createElement(Typography, { variant: 'body2' }, TEXTS.CONTACT[language])),
        React.createElement("div", { className: classes.supportContainer },
            React.createElement("h4", { className: classes.support }, TEXTS.SUPPORT[language]),
            React.createElement("a", { href: "mailto:maestro.support@michelin.com", className: classes.link }, "maestro.support@michelin.com"))));
};
//# sourceMappingURL=AppOffline.js.map